// Domain constants with default fallback values
// For runtime values, use getServerRuntimeConfig() in server components
// Note: These domains are typically not sensitive and can use defaults
export const domains = {
  dev: 'https://dev.giftcardmarket.com',
  qa: 'https://qa.giftcardmarket.com',
  stage: 'https://stage.giftcardmarket.com',
  demo: 'https://demo.giftcardmarket.com',
  prod: 'https://www.giftcardmarket.com',
  b2b_dev: 'https://dev.b2b.giftcardmarket.com',
  b2b_qa: 'https://qa.b2b.giftcardmarket.com',
  partner_dev: "https://devpartner.giftcardmarket.com",
  partner_qa: "https://qapartner.giftcardmarket.com",
  partner_demo: "https://demopartner.giftcardmarket.com",
  partner_prod: "https://partner.giftcardmarket.com"
} as const
